/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import {ModuleWithProviders, NgModule} from "@angular/core";
import {CommonState} from "@app/store/common/common.state";
import {ConfigurationState} from "@app/store/configuration/configuration.state";
import {environment} from "@env/environment";
import {NgxsActionsExecutingModule} from "@ngxs-labs/actions-executing";
import {NgxsReduxDevtoolsPluginModule} from "@ngxs/devtools-plugin";
import {NGXS_PLUGINS, NgxsModule} from "@ngxs/store";
import {TrecEnvironmentService} from "@trec/api/utils";
import {C3ErrorMsgDisplayPlugin, C3ErrorMsgDisplayPluginOptions} from "@trec/components/store";
import {PushMsgState} from "./push-msg/push-msg.state";

@NgModule({
  imports: [
    // Setup store
    NgxsModule.forRoot([CommonState, PushMsgState, ConfigurationState], {
      developmentMode: !environment.production,
    }),

    NgxsActionsExecutingModule.forRoot(),

    // Setup dev tools only in dev environment
    environment.production ? [] : NgxsReduxDevtoolsPluginModule.forRoot({disabled: environment.production}),
    //NgxsReduxDevtoolsPluginModule.forRoot()
  ],
})
export class AppStoreModule {
  static forRoot(): ModuleWithProviders<AppStoreModule> {
    return {
      ngModule: AppStoreModule,
      providers: [
        {
          // C3ErrorMsgDisplayPlugin configurations
          provide: C3ErrorMsgDisplayPluginOptions,
          useFactory: (trecEnv: TrecEnvironmentService) => ({
            hideKibanaBtn: trecEnv.getTrecEnvironment() !== "development",
          }),
          deps: [TrecEnvironmentService],
        },
        {
          provide: NGXS_PLUGINS,
          useClass: C3ErrorMsgDisplayPlugin,
          multi: true,
        },
      ],
    };
  }
}
